module.exports = __webpack_public_path__ + "static/img/img-fa4.f602c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-fa4.png
// module id = aBTI
// module chunks = 0